import React from "react";
import "./style.css";
import { introdata } from "../../content_option";

export const Home = () => (
  <section id="home" className="home">
    <div className="intro_sec">
      <div className="hero__copy">
        <p className="hero__hello"><span>Hello, I’m</span> <strong>Hamza Zahid</strong></p>
        <span className="hero__eyebrow"><span className="hero__dot" /> VIDEO EDITOR · AVAILABLE FOR PROJECTS</span>
        <h1 className="hero__role"><span className="hero__line">I shape footage</span><span className="hero__line hero__line--accent">into stories.</span></h1>
        <p className="hero__desc">{introdata.description}</p>
        <div className="hero__stack" aria-label="Editing specialties">
          {introdata.stack.slice(0, 4).map((tech, index) => <span className={`hero__chip${index === 0 ? " hero__chip--featured" : ""}`} key={tech}><span className="hero__chip-mark" aria-hidden="true">0{index + 1}</span>{tech}</span>)}
        </div>
        <div className="intro_btn-action">
          <a href="#portfolio"><span id="button_p" className="ac_btn">Explore my work</span></a>
          <a href="#contact"><span id="button_h" className="ac_btn">Let’s talk</span></a>
        </div>
      </div>
      <div className="hero__visual">
        <div className="hero__portrait" style={{ backgroundImage: `url(${introdata.your_img_url})` }} role="img" aria-label="Portrait of Hamza Zahid" />
        <div className="hero__caption"><span className="hero__caption-mark" aria-hidden="true">▶</span><span><strong>Thoughtful edits.</strong><br />Made to keep people watching.</span></div>
        <div className="hero__index" aria-hidden="true">01 / 07</div>
      </div>
    </div>
    <div className="hero__rule"><span>STORY</span><span className="hero__rule-line" /><span>PACE</span><span className="hero__rule-line" /><span>FEELING</span></div>
  </section>
);
